import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import { getHosts as getHostsQuery } from '../graphql/queries'
import {
  refreshHostCode as refreshHostCodeMutation,
  cognitoUpdateUser as cognitoUpdateUserMutation,
  updateHost as updateHostMutation,
} from '../graphql/mutations'

export const useHosts = () => {
  const client = useMemo(() => generateClient(), [])
  const getHosts = useCallback(async () => {
    return client.graphql({
      query: getHostsQuery,
    })
  }, [client])

  const refreshHostCode = useCallback(
    async (hostId, hostNumber) => {
      return client.graphql({
        query: refreshHostCodeMutation,
        variables: {
          input: { hostId, hostNumber },
        },
      })
    },
    [client],
  )

  const updateHostCodeInCognito = useCallback(
    (groupName, userId, newAccessCode) => {
      const userName = `${groupName}${userId}`

      return client.graphql({
        query: cognitoUpdateUserMutation,
        variables: {
          input: { userName, newAccessCode },
        },
      })
    },
    [client],
  )

  const getHostNumber = useCallback((hosts, hostId) => {
    return hosts.findIndex((host) => host.id === hostId)
  }, [])

  const updateHostName = useCallback(
    (id, hostName) => {
      return client.graphql({
        query: updateHostMutation,
        variables: {
          input: { id, hostName },
        },
      })
    },
    [client],
  )

  return {
    getHosts,
    getHostNumber,
    refreshHostCode,
    updateHostCodeInCognito,
    updateHostName,
  }
}
